// Handle adding more that one attachment to a form
const addAttachmentButton = document.querySelector('.contact-form-section__add-attachment, .form-builder .add-attachment');
const buttonLimit = 4;

if (addAttachmentButton) {
  addAttachmentButton.addEventListener('click', () => {
    // Add a new file input
    const newInput = document.createElement('input');
    newInput.setAttribute('type', 'file');
    newInput.setAttribute('name', 'attachment[]');
    addAttachmentButton.parentNode.insertBefore(newInput, addAttachmentButton);
    // Hide the button if we've reached our limit
    if (document.querySelectorAll('.contact-form-section input[name="attachment[]"], .form-builder input[name="attachment[]"]').length >= buttonLimit) {
      addAttachmentButton.style.display = 'none';
    }
  });
}
